/**
 * Paleta comună pentru viteza vântului (inspirată de scara Beaufort).
 *
 * Folosită atât de animația 2D pe canvas, cât și de particulele 3D din
 * Cesium, ca cele două vizualizări să arate identic la aceeași viteză.
 */

export const WIND_COLORS = [
  { speed: 0,  color: [180, 220, 255, 0.45] },  // calm: albastru pal
  { speed: 2,  color: [120, 220, 255, 0.65] },  // ușor: cyan
  { speed: 4,  color: [60,  240, 200, 0.75] },  // lin: turcoaz
  { speed: 7,  color: [80,  255, 140, 0.80] },  // moderat: verde
  { speed: 10, color: [220, 250, 60,  0.85] },  // tare: galben
  { speed: 14, color: [255, 190, 40,  0.90] },  // puternic: portocaliu
  { speed: 18, color: [255, 110, 60,  0.92] },  // f. puternic: roșu-portocaliu
  { speed: 25, color: [240, 60,  80,  0.95] },  // furtună: roșu
  { speed: 35, color: [220, 60,  210, 1.00] },  // uragan: mov
];

/**
 * Interpolează paleta la o viteză dată.
 * @param {number} speed viteza în m/s
 * @returns {[number, number, number, number]} [r, g, b, a] cu r/g/b în 0–255 și a în 0–1
 */
export function windColorRGBA(speed) {
  const last = WIND_COLORS.length - 1;
  let i = 0;
  while (i < last && speed > WIND_COLORS[i + 1].speed) i++;
  if (i >= last) return [...WIND_COLORS[last].color];

  const lo = WIND_COLORS[i], hi = WIND_COLORS[i + 1];
  const f = (speed - lo.speed) / (hi.speed - lo.speed);
  return [
    lo.color[0] + f * (hi.color[0] - lo.color[0]),
    lo.color[1] + f * (hi.color[1] - lo.color[1]),
    lo.color[2] + f * (hi.color[2] - lo.color[2]),
    lo.color[3] + f * (hi.color[3] - lo.color[3]),
  ];
}

/** Aceeași culoare, ca string CSS — pentru randarea pe canvas 2D. */
export function windColorCss(speed) {
  const [r, g, b, a] = windColorRGBA(speed);
  return `rgba(${r | 0},${g | 0},${b | 0},${a.toFixed(2)})`;
}
